/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { BlueBirds, BlueBirdsInterface } from "../BlueBirds";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_baseUri",
        type: "string",
      },
      {
        internalType: "string",
        name: "_baseContractUri",
        type: "string",
      },
      {
        internalType: "address",
        name: "_proxyAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "SetBaseURI",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "contractURI",
        type: "string",
      },
    ],
    name: "SetContractURI",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256",
      },
    ],
    name: "SetFee",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "proxyAddress",
        type: "address",
      },
    ],
    name: "SetProxyAddress",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseTokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "exists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "fee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "hatch",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "beneficiary",
        type: "address",
      },
    ],
    name: "hatchTo",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proxyRegistryAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseUri",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "contractUri",
        type: "string",
      },
    ],
    name: "setContractURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newFee",
        type: "uint256",
      },
    ],
    name: "setFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAddress",
        type: "address",
      },
    ],
    name: "setRegistryAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

export class BlueBirds__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _baseUri: string,
    _baseContractUri: string,
    _proxyAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<BlueBirds> {
    return super.deploy(
      _baseUri,
      _baseContractUri,
      _proxyAddress,
      overrides || {}
    ) as Promise<BlueBirds>;
  }
  getDeployTransaction(
    _baseUri: string,
    _baseContractUri: string,
    _proxyAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _baseUri,
      _baseContractUri,
      _proxyAddress,
      overrides || {}
    );
  }
  attach(address: string): BlueBirds {
    return super.attach(address) as BlueBirds;
  }
  connect(signer: Signer): BlueBirds__factory {
    return super.connect(signer) as BlueBirds__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BlueBirdsInterface {
    return new utils.Interface(_abi) as BlueBirdsInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BlueBirds {
    return new Contract(address, _abi, signerOrProvider) as BlueBirds;
  }
}
